import React from 'react';
import Header from './Header';

function Projects() {
    return (
        <div>
            <Header />
            <p>This is Projects page</p>
        </div>
    )
}

export default Projects;